import React from 'react';
import { ApolloClient, InMemoryCache, HttpLink, ApolloProvider } from '@apollo/client';
import ReactOnRails from 'react-on-rails';
import SprintDetailContainer from '../containers/SprintDetailContainer';
import SprintCreateModal from '../components/Sprints/SprintCreateModal';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';
import GuidedTour from '../components/Shared/GuidedTour/GuidedTour';

const client = new ApolloClient({
  link: new HttpLink({
    uri: '/graphql',
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': ReactOnRails.authenticityToken() },
  }),
  cache: new InMemoryCache(),
});

class SprintDetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreateOpen: false,
      sprintId: props.sprintId,
      tourOpen: false,
    };
  }

  componentDidMount() {
    this._handler = () => this.setState({ isCreateOpen: true });
    window.addEventListener('open-sprint-create', this._handler);

    // Launch guided tour for exit plan sprint when query param present
    try {
      const params = new URLSearchParams(window.location.search || '');
      if (params.get('exitPlanTour') === '1') {
        this.setState({ tourOpen: true });
      }
    } catch (_) {}
  }

  componentWillUnmount() {
    if (this._handler) window.removeEventListener('open-sprint-create', this._handler);
  }

  render() {
    const { isCreateOpen, sprintId, tourOpen } = this.state;
    return (
      <ApolloProvider client={client}>
        <SuccessionThemeProvider company={this.props?.company} user={this.props?.current_user}>
          <SprintDetailContainer sprintId={sprintId} />
          <SprintCreateModal
            isOpen={isCreateOpen}
            onClose={() => this.setState({ isCreateOpen: false })}
            ownerName={this.props?.current_user?.allowed_name || this.props?.current_user?.name}
            onCreated={(sprint) => this.setState({ isCreateOpen: false, sprintId: sprint.id })}
          />
          <GuidedTour
            isOpen={tourOpen}
            onClose={() => this.setState({ tourOpen: false })}
            onComplete={() => this.setState({ tourOpen: false })}
            onReplayRequest={() => this.setState({ tourOpen: true })}
            steps={[
              {
                id: 'backlog-items',
                title: 'Exit Plan Sprint',
                description: "Congratulations on taking the first step toward exit. We've added suggested exit planning activities to your backlog to help you reach the finish line.",
                targetSelector: '[data-tutorial-id="sprint-backlog"], .flex-1.min-h-96',
                position: 'right',
              },
            ]}
          />
        </SuccessionThemeProvider>
      </ApolloProvider>
    );
  }
}

export default SprintDetailPage;


